import { z } from 'zod';
import { urlValidator } from '../pdf/zod.utils';

export const contentLegacyGuideSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  contentId: z.number().int().positive('Content ID must be positive'),
  count: z.number().int().min(1, 'Count must be non-negative'),
});

export const contentTabSchema = z.object({
  name: z.string().min(1, 'Name is required'),
});

export const contentLinkSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  url: urlValidator,
  coverImage: z
    .string()
    .url('Must be a valid URL')
    .nullable()
    .or(z.literal(''))
    .optional(),
});

export const contentImageSchema = z.object({
  title: z.string().min(1, 'Title is required').optional(),
  url: urlValidator.optional(),
  file: z.instanceof(File).optional(),
});

export const extrasFormSchemaMap = {
  ContentLegacyGuide: contentLegacyGuideSchema,
  ContentTab: contentTabSchema,
  ContentLink: contentLinkSchema,
  ContentImage: contentImageSchema,
} as const;

export const validateImage = async (
  file: File,
  minWidth = 1005,
  minHeight = 450,
): Promise<{ isValid: boolean; error?: string; url?: string }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(img.src);

      if (img.width < minWidth || img.height < minHeight) {
        resolve({
          isValid: false,
          error: `Image must be larger than ${minWidth}x${minHeight} pixels.`,
        });
        return;
      }

      resolve({ isValid: true });
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      resolve({
        isValid: false,
        error: 'Failed to load image. Please try a different file.',
      });
    };
  });
};
